import React from "react";

// IMAGE IMPORTS
import blog08 from "../../../images/blog/blog5.jpg";
import { Link } from "react-router-dom";
import CommentForm from "../CommentForm";
import RelatedBlog from "../RelatedBlog";
import ItemDetailsContent from "./ItemDetailsContent";
const MachineLearning: React.FC = () => {
  return (
    <section className="blog_details_section pt-70">
      <div className="container">

        {/* MAIN IMAGE */}
        <div className="single-item-image mb-70">
          <img src={blog08} alt="Blog" />
        </div>

        {/* HEADER META */}
        <ItemDetailsContent />

        {/* CONTENT ROW */}
        <div className="row mt-none-30 g-0 align-items-center">
          <div className="col-lg-12  container">

            <div className="blog_details_content">

              {/* AUDIO BUTTON */}
              {/* <div className="post_audio">
                <button className="audio_play_btn xb-border" type="button">
                  <i className="fas fa-play"></i>
                  <span className="time">6:24</span>
                  <span>Listen to this article!</span>
                </button>
              </div> */}

              {/* MAIN HEADING */}
              <h3 className="item_details_info_heading mb-35">
                ML solutions that evolve with your business and data.
              </h3>

              {/* <div className="row mb-35 mt-none-30">
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog09} alt="Blog" />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog10} alt="Blog" />
                  </div>
                </div>
              </div> */}

              <p>
               We build machine learning solutions designed to make your business more intelligent, efficient, and adaptive. Our models do more than analyze historical data—they identify trends, detect anomalies, and predict future outcomes to support strategic decision-making.
              </p>

              <p className="mt-20">
               We work closely with organizations to understand their workflows, challenges, and goals. From automating routine operations to optimizing complex business processes, our ML solutions deliver measurable results. Each model is tailored to ensure accuracy, scalability, and alignment with real business priorities.
              </p>
              {/* VIDEO EMBED */}
              <div className="row mb-45 align-items-center mt-60">
                <div className="col-md-6 mt-30">
              <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/Beh13Cd_QbY?si=cqkLK1tAT1M7yP6B" title="YouTube video player"allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
                </div>

                <div className="col-md-6 mt-30">
                  <ul className="iconlist_block">
                    <li><span className="iconlist_text">Adaptive Predictions.</span></li>
                    <li><span className="iconlist_text">Real-Time Insights.</span></li>
                    <li><span className="iconlist_text">Intelligent Automation.</span></li>
                    <li><span className="iconlist_text">Pattern & Anomaly Detection.</span></li>
                    <li><span className="iconlist_text">Custom ML Models.</span></li>
                    <li><span className="iconlist_text">Scalable Deployment.</span></li>
                  </ul>
                </div>
              </div>

              <h3 className="item_details_info_heading mb-20 mt-60">
               Turning Data Into Continuous Learning
              </h3>

              <p className="mb-40">
               Machine learning systems thrive on data. By processing information from multiple sources in real time, ML models uncover insights that humans might miss. Over time, these systems refine their predictions and recommendations, providing smarter, faster, and more reliable guidance.<br></br>
              Whether it’s improving operational efficiency, enhancing customer experiences, or driving revenue growth, machine learning empowers businesses to act proactively rather than reactively.
              </p>
              

              {/* IMAGE + LIST */}
             

              <h3 className="item_details_info_heading mb-25">3 Ways Machine Learning Drives Business Success</h3>

              <ul className="iconlist_block numlist_block list-unstyled">
                <li><span className="iconlist_text">1. Smarter Decisions, Faster.</span></li>
                <li><span className="iconlist_text">2. Operational Efficiency.</span></li>
                <li><span className="iconlist_text">3. Continuous Improvement.</span></li>
              </ul>

              {/* AUTHOR BLOCK */}
              {/* <div className="post-block-wrap mb-50">
                <div className="postabmin_block xb-border ul_li">

                  <div className="admin_image">
                    <img src={avatar1} alt="Author" />
                  </div>

                  <div className="admin_content">
                    <h4 className="admin_name">Aiden Brooks</h4>
                    <span className="admin_designation">Content Manager</span>
                    <p>A content editor plays a pivotal role in shaping and refining digital content...</p>

                    <ul className="social_icons_blocks list-unstyled ul_li">
                      <li><Link to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>

                </div>
              </div> */}

              {/* TAGS + SOCIAL */}
              <div className="row mt-none-30">
                {/* <div className="col-md-6 mt-30">
                  <ul className="tags_block list-unstyled">
                    <li><Link className="xb-border" to="/blog-details">AI Solutions</Link></li>
                    <li><Link className="xb-border" to="/blog-details">Data Science</Link></li>
                    <li><Link className="xb-border" to="/blog-details">SaaS</Link></li>
                  </ul>
                </div> */}

                {/* <div className="col-md-6 mt-30">
                  <ul className="social_icons_block list-unstyled ul_li justify-content-md-end">
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-twitter"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fas fa-share-alt"></i></Link></li>
                  </ul>
                </div> */}
              </div>

              {/* COMMENTS AREA */}
              {/* <CommentsArea /> */}

              {/* COMMENT FORM */}
              <CommentForm />

              {/* SUBSCRIBE BOX */}
              {/* <NewsletterBox /> */}
            </div>
          </div>
          {/* <BlogSidebar /> */}
        </div>

        <RelatedBlog/>

      </div>
    </section>
  );
};

export default MachineLearning;
